module.exports = __webpack_public_path__ + "img/xukui.f1e88e90.png";